import { PostJson, PatchJson } from './helpers';

export function GetBroadcastServer(token: string, session_uuid: string): Promise<any> {
	return PostJson({
		path: `/v3/admin/broadcast/${session_uuid}`,
		token,
		headers: { 'bl-profile-token': token },
		data: {}
	});
}

export function StartBroadcast(token: string, session_uuid: string, resolution: string): Promise<any> {
	return PatchJson({
		path: `/v3/admin/broadcast/${session_uuid}/start/`,
		token,
		data: { resolution },
		headers: { 'bl-profile-token': token }
	});
}

export function StopBroadcast(token: string, session_uuid: string): Promise<any> {
	return PatchJson({
		path: `/v3/admin/broadcast/${session_uuid}/stop`,
		token,
		data: {},
		headers: { 'bl-profile-token': token }
	});
}

